function copy(source, keys) {
  const result = {};
  for (const key of keys) {
    result[key] = source[key];
  }
  return result;
}

const dataKeywords = {
  'time-series-data-keywords': 'time series data',
  'geospatial-data-keywords': 'geospatial data',
  'tabular-data-keywords': 'tabular data',
  'monitoring-data-keywords': 'monitoring data',
  'modeled-data-keywords': 'modeled data',
};

const timeSeriesKeywords = {
  'time-series-keywords-time series data': 'time series data',
  'time-series-keywords-monitoring data':  'monitoring data',
  'time-series-keywords-modeled data':     'modeled data',
  'time-series-keywords-main':             'query interface'
};

const aboutKeywords = {
  'catalog-keywords': 'data catalog',
  ...copy(timeSeriesKeywords, [ 'time-series-keywords-main' ]),
  'map-keywords': 'map interface',
  'api-keywords': 'Application Programming Interface (API)',
  'visualizations-keywords': 'data visualizations',
};

const sectionKeywords = {
  ...aboutKeywords,
  'faq-keywords': '',
  'download-api-keywords': aboutKeywords['api-keywords'],
};

export const strings = {
  ...dataKeywords,
  ...sectionKeywords,
  ...timeSeriesKeywords,
  'base-keywords': [
    'open data', 'Department of the Interior', 'Bureau of Reclamation', 'Western US',
  ].join(', '),
  'data-keywords': Object.values(dataKeywords).join(', '),
  'time-series-keywords': Object.values(timeSeriesKeywords).join(', '),
  'about-keywords': Object.values(aboutKeywords).join(', '),

  'close-modal': 'Close Dialog',

  'account-profile':  'Profile',
  'account-searches': 'My Saved Searches',
  'account-queries':  'My Saved Queries',
  'account-alerts':   'My Alerts',

  'contact-error-topic-required':   'Topic is required.',
  'contact-error-subject-required': 'Subject is required.',
  'contact-error-message-required': 'Message is required.',
  'contact-error-email':            'Email address invalid.',
  'contact-error-unknown':          'Unknown error. Please try again later.',
  'contact-error-captcha':          'Captcha error. Please try again later.',
  'contact-error-captcha-fail':     'Please complete the captcha and try again.',
  'contact-error-mail':             'Error sending mail. Please try again later.',

  'help-search-meta-description': 'Get help using the RISE Catalog, Time Series '
    + 'Query, Map Interface, and APIs to find, view, access, and download data.',
  'help-catalog-meta-description': 'Get help using the RISE Catalog. The RISE Catalog '
    + 'allows you to search for data and reports on water, reservoir operations, '
    + 'water quality, hydropower, endangered and invasive species, and more from '
    + 'the Bureau of Reclamation.',
  'help-time-series-meta-description': 'Get help using the RISE Time Series Query. '
    + 'The RISE Time Series Query allows you to search and select locations, '
    + 'specify parameters and date ranges, generate plots, and download time series '
    + 'data from the Bureau of Reclamation on water, reservoir operations, water '
    + 'quality, hydropower, endangered and invasive species, and more at sub-hourly '
    + 'to annual intervals.',
  'help-map-meta-description': 'Get help using the RISE Map Interface. The RISE '
    + 'map interface allows you to find and interact with data from the Bureau of '
    + 'Reclamation on water, reservoir operations, water quality, hydropower, '
    + 'endangered and invasive species, and more in a map interface.',
  'help-visualizations-meta-description': '',
  'help-faq-meta-description': 'Get answers to Frequently Asked Questions about RISE',
  'help-api-meta-description': 'Get help using the RISE Application Programing '
    + 'Interface (API). The RISE API provides access to data and metadata from '
    + 'the Bureau of Reclamation on water, reservoir operations, water quality, '
    + 'hydropower, endangered and invasive species, and more.',
  'help-download-api-meta-description': 'Get help using the RISE Download Application '
    + 'Programing Interface (API). The RISE Download API allows you to download '
    + 'machine-readable data in CSV and JSON formats.',

  'time-series-route':                   'Time Series Query',
  'time-series-search-route':            'Select Locations',
  'time-series-selection-route':         'Specify Query',
  'time-series-output-route':            'Generate Outputs',
  'time-series-selected-locations':      'Selected Locations',
  'time-series-select-locations-prompt': 'No locations selected',
  'first-datum':                         'First Datum',
  'last-datum':                          'Last Datum',
  'clear-all-dates':                     'Clear All Dates',
  'default-dates':                       'Default Date Range',
  'clear-default-dates':                 'Clear Default Date Range',
  'copy-default-dates':                  'Copy Dates from Default Dates',

  'location-title':                       'Location',
  'location-subtitle':                    'Location {{id}}',
  'location-heading':                     'Location',
  'location-indirect-label':              'Location',
  'location-indirect-name-label':         'Location Name',
  'location-indirect-description-label':  'Location Description',
  'location-indirect-description-empty':  'No Location Description',
  'location-tags-label':                  'Location Tags',
  'location-tags-empty':                  'No Location Tags',
  'location-parent-label':                'Location Parent',
  'location-parent-empty':                'No Location Parent',
  'location-states-label':                'State(s)',
  'location-states-empty':                'No States',
  'location-unified-regions-label':       'Unified Region(s)',
  'location-unified-regions-empty':       'No Unified Regions',
  'location-reclamation-regions-label':   'Reclamation Region(s) (Legacy)',
  'location-reclamation-regions-empty':   'No Reclamation Regions',
  'location-timezone-label':              'Timezone',
  'location-timezone-empty':              'No Timezone',
  'location-elevation-label':             'Elevation',
  'location-elevation-empty':             'No Elevation',
  'location-vertical-datum-label':        'Vertical Datum',
  'location-vertical-datum-empty':        'No Vertical Datum',
  'location-horizontal-datum-label':      'Horizontal Datum',
  'location-horizontal-datum-empty':      'No Horizontal Datum',
  'location-coordinates-label':           'Coordinates (lat, long)',
  'location-coordinates-empty':           'No Coordinates',
  'location-map-link':                    'Map Location',
  'location-related-locations-heading':   'Related Locations',
  'location-associated-heading':          'Associated Datasets',
  'location-no-records-hint':             'No Catalog Records associated with this Location',
  'location-indirect-heading':            'Location Information',
  'location-link':                        'Location Details',
  'location-no-related-locations-hint':   'No Related Locations',

  'record-heading':                           'Catalog Record',
  'record-indirect-title-label':              'Catalog Record Title',
  'record-themes-label':                      'Themes',
  'record-themes-empty':                      'No Themes',
  'record-tags-label':                        'Tags',
  'record-tags-empty':                        'No Tags',
  'record-project-label':                     'Reclamation Project',
  'record-project-empty':                     'No Reclamation Project',
  'record-program-label':                     'Reclamation Program',
  'record-program-empty':                     'No Reclamation Program',
  'record-generation-effort-label':           'Generation Effort',
  'record-generation-effort-empty':           'No Generation Effort',
  'record-related-records-heading':           'Related Records',
  'record-location-records-heading':          'Other Records with the Same Location',
  'record-generation-effort-records-heading': 'Other Records with the Same Generation Effort',
  'record-items-heading':                     'Associated Items',
  'record-metadata-heading':                  'Catalog Record Metadata',
  'record-download-metadata-link':            'Download Metadata',
  'record-no-items-hint':                     'No Items associated with this Record',

  'catalog-item':                        'catalog item',
  'catalog-items':                       'catalog items',
  'item-subtitle':                       'Item {{id}}',
  'item-type-label':                     'Type',
  'item-modeled-label':                  'Modeled/Observed',
  'item-modeled-value':                  'Modeled',
  'item-observed-value':                 'Observed',
  'item-temporal-heading':               'Time Series Information',
  'item-update-frequency-label':         'Update Frequency',
  'item-update-frequency-empty':         'No Update Frequency',
  'item-update-date-label':              'Last Update',
  'item-update-date-empty':              'No Last Update',
  'item-start-date-label':               'Start Date',
  'item-start-date-empty':               'No Start Date',
  'item-end-date-label':                 'End Date',
  'item-end-date-empty':                 'No End Date',
  'item-parameter-name-label':           'Parameter Name',
  'item-parameter-name-empty':           'No Parameter Name',
  'item-parameter-group-label':          'Parameter Group',
  'item-parameter-group-empty':          'No Parameter Group',
  'item-parameter-transformation-label': 'Parameter Transformation',
  'item-parameter-transformation-empty': 'No Parameter Transformation',
  'item-parameter-timestep-label':       'Time Step',
  'item-parameter-timestep-empty':       'No Time Step',
  'item-parameter-unit-label':           'Parameter Unit',
  'item-parameter-unit-empty':           'No Parameter Unit',
  'item-time-series-link':               'Query Data',
  'item-spatial-heading':                'Geospatial Information',
  'item-spatial-geometry-label':         'Geometry',
  'item-spatial-geometry-empty':         'No Geometry',
  'item-spatial-resolution-label':       'Resolution',
  'item-spatial-resolution-empty':       'No Resolution',
  'item-spatial-transformation-label':   'Transformation',
  'item-spatial-transformation-empty':   'No Transformation',
  'item-map-link':                       'Map Data',
  'item-file-heading':                   'Uploaded File Information',
  'item-file-format-label':              'File Type',
  'item-file-format-empty':              'No File Type',
  'item-publisher-label':                'Publisher',
  'item-publisher-empty':                'No Publisher',
  'item-publication-date-label':         'Publication Date',
  'item-publication-date-empty':         'No Publication Date',
  'item-download-file-link':             'Download File',
  'item-disclaimer-heading':             'Disclaimer',
  'item-record-items-heading':           'More Items From This Item’s Catalog Record',
  'item-record-metadata-heading':        'Catalog Record Metadata',
  'item-download-metadata-link':         'Download Metadata',
  'item-vertical-datum-label':           'Item Vertical Datum',
  'item-vertical-datum-empty':           'No Item Vertical Datum',

  'model-run':           'model run',
  'model-runs':          'model runs',
  'model-run-profile':   'profile',
  'model-run-profiles':  'profiles',
  'model-run-member':    'model run member',
  'model-run-members':   'model run members',

  'title-case-blacklist': [ 'a', 'an', 'the', 'and', 'but', 'for', 'at', 'by', 'to', 'in', 'on' ],
};
export default strings;
